{
  "tabs": {
    "chat": "Sembang",
    "reminders": "Peringatan",
    "calendar": "Kalendar",
    "settings": "Tetapan"
  },
  "common": {
    "cancel": "Batal",
    "save": "Simpan",
    "confirm": "Sahkan",
    "delete": "Padam",
    "back": "Kembali",
    "close": "Tutup",
    "edit": "Sunting",
    "search": "Cari",
    "all": "Semua",
    "loading": "Memuatkan...",
    "error": "Ada masalah berlaku",
    "notFound": "Tidak dijumpai",
    "tryAgain": "Sila cuba lagi",
    "retry": "Cuba semula",
    "undo": "Batal",
    "pullToRefresh": "Tarik untuk segar semula",
    "justNow": "baru sahaja"
  },
  "auth": {
    "welcome": "Selamat datang ke FishMemory",
    "tagline": "Pembantu peringatan WhatsApp anda, kini di poket anda.",
    "subtitle": "Pembantu peringatan WhatsApp anda, kini di poket anda.",
    "phoneLabel": "Nombor WhatsApp anda",
    "phoneHint": "Kami akan hantar kod pengesahan melalui WhatsApp",
    "invalidPhone": "Sila masukkan nombor telefon yang sah",
    "continue": "Teruskan",
    "enterPhone": "Masukkan nombor WhatsApp anda",
    "phonePlaceholder": "Nombor telefon",
    "sendCode": "Hantar Kod",
    "verifyTitle": "Sahkan nombor anda",
    "otpSentTo": "Kod 6 digit telah dihantar ke {{phone}} melalui WhatsApp",
    "enterFullCode": "Sila masukkan semua 6 digit",
    "invalidOtp": "Kod tidak sah. Sila cuba lagi.",
    "otpFailed": "Gagal menghantar kod. Cuba lagi.",
    "otpResent": "Kod dihantar semula",
    "resendIn": "Hantar semula dalam {{seconds}}s",
    "resendCode": "Hantar semula kod",
    "enterOtp": "Masukkan kod yang dihantar ke WhatsApp anda",
    "verify": "Sahkan",
    "resend": "Hantar semula kod",
    "wrongNumber": "Nombor salah?",
    "backToPhone": "Kembali ke telefon",
    "editPhone": "Sunting nombor telefon",
    "error": "Ralat",
    "setupTitle": "Mari tetapkan",
    "setupSubtitle": "Anda boleh ubah ini kemudian dalam Tetapan",
    "namePlaceholder": "Nama anda",
    "letsGo": "Selesai tetapan",
    "skipForNow": "Langkau buat masa ini"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "Taip mesej...",
    "inputPlaceholder": "Taip mesej...",
    "typing": "FishMemory sedang menaip...",
    "online": "Dalam talian",
    "connecting": "Menyambung...",
    "reconnecting": "Menyambung semula...",
    "offline": "Luar talian",
    "empty": "Mulakan perbualan",
    "emptyHint": "Buat peringatan, semak jadual, atau minta bantuan.",
    "emptyAction": "Hantar peringatan contoh",
    "actions": "Tindakan sembang",
    "keep": "Simpan mesej",
    "clearTitle": "Kosongkan sembang",
    "clearConfirm": "Padam semua mesej dari peranti ini? Tindakan ini tidak boleh dibatalkan.",
    "clear": "Kosongkan sembang",
    "optionSelected": "Dipilih: {{label}}",
    "sendingSelection": "Menghantar...",
    "connectionLost": "Menyambung semula..."
  },
  "reminders": {
    "title": "Peringatan Saya",
    "active": "Aktif",
    "today": "Hari Ini",
    "thisWeek": "Minggu Ini",
    "history": "Sejarah",
    "items": "item",
    "emptyTitle": "Tiada peringatan lagi",
    "emptySubtitle": "Buat satu dari sembang dan ia akan muncul di sini.",
    "emptyAction": "Buka sembang",
    "filterActive": "Aktif",
    "filterToday": "Hari Ini",
    "filterWeek": "Minggu Ini",
    "filterHistory": "Sejarah",
    "emptyState": "Tiada peringatan lagi. Mula berbual!",
    "swipeDone": "Selesai",
    "swipeSnooze": "Tunda",
    "swipeDelete": "Padam",
    "search": "Cari peringatan...",
    "upcoming": "Akan datang",
    "completed": "Selesai",
    "overdue": "Lewat",
    "tomorrow": "Esok",
    "synced": "Diselaraskan {{value}}",
    "swipeHint": "Leret peringatan untuk lebih tindakan",
    "noResults": "Tiada peringatan sepadan carian anda",
    "noResultsHint": "Cuba kata kunci lain atau kosongkan carian",
    "deleteAllFailed": "Gagal memadam semua peringatan"
  },
  "calendar": {
    "title": "Kalendar",
    "today": "Hari Ini",
    "tomorrow": "Esok",
    "completed": "selesai",
    "noEvents": "Tiada jadual",
    "noEventsSubtitle": "Pilih tarikh untuk lihat peringatan dan acara kalendar.",
    "googleEvent": "Google Calendar",
    "legendActive": "Aktif",
    "legendRecurring": "Berulang",
    "legendDone": "Selesai",
    "legendGoogle": "Google",
    "previousMonth": "Bulan lepas",
    "nextMonth": "Bulan depan",
    "previousYear": "Tahun lepas",
    "nextYear": "Tahun depan",
    "goToToday": "Pergi ke hari ini",
    "all": "Semua",
    "active": "Aktif",
    "done": "Selesai",
    "paused": "Jeda"
  },
  "settings": {
    "title": "Tetapan",
    "profile": "Profil",
    "name": "Nama Paparan",
    "enterName": "Masukkan nama anda",
    "language": "Bahasa",
    "uiLanguage": "Bahasa aplikasi",
    "uiLanguageHelp": "Tukar UI aplikasi, label kalendar, dan arah susun atur pada peranti ini sahaja.",
    "serverLanguage": "Bahasa sembang",
    "serverLanguageHelp": "Tukar bahasa balasan server dan mesej peringatan untuk akaun anda.",
    "timezone": "Zon masa",
    "currentTimezone": "Zon masa semasa",
    "timezoneHelp": "Semua masa peringatan dipaparkan menggunakan zon masa ini.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "Simpan zon masa",
    "timezoneSaved": "Zon masa dikemas kini",
    "detect": "Kesan",
    "detectFailed": "Gagal mengesan zon masa",
    "autoDetect": "Kesan automatik dari GPS",
    "notifications": "Pemberitahuan",
    "notificationsHelp": "Peringatan susulan mengawal amaran berulang selepas peringatan dihantar. Kebenaran pemberitahuan di peranti masih dikawal dalam tetapan telefon anda.",
    "pushEnabled": "Pemberitahuan Tolak",
    "autoDoneOnFire": "Tandakan selesai automatik bila diaktifkan",
    "autoDoneOnFireDesc": "Jika dimatikan, peringatan kekal aktif sehingga anda tandakan selesai.",
    "googleCalendar": "Google Calendar",
    "google": "Google Calendar",
    "googleConnected": "Bersambung",
    "googleDisconnected": "Tidak bersambung",
    "googleConnectedHelp": "Peringatan baru boleh diselaraskan ke kalendar anda secara automatik.",
    "googleDisconnectedHelp": "Sambungkan Google Calendar untuk selaraskan peringatan dan acara.",
    "googleConnectFailed": "Gagal sambung Google Calendar",
    "connected": "Bersambung",
    "disconnected": "Tidak bersambung",
    "connect": "Sambung",
    "disconnect": "Putus sambungan",
    "autoSync": "Selaraskan peringatan baru automatik",
    "autosync": "Selaraskan peringatan baru automatik",
    "subscription": "Langganan",
    "trialUsed": "Percubaan: {{used}}/{{total}} digunakan",
    "trialStatus": "Percubaan tersedia",
    "activeStatus": "Langganan aktif",
    "expiredStatus": "Langganan tamat",
    "unsubscribedStatus": "Tidak melanggan",
    "about": "Mengenai",
    "version": "Versi",
    "logout": "Log Keluar",
    "logoutTitle": "Log Keluar",
    "logoutConfirm": "Anda pasti mahu log keluar?",
    "noName": "Tiada nama ditetapkan",
    "serverConnection": "Sambungan server",
    "serverUrl": "URL server",
    "serverEdit": "Sunting",
    "saveReconnect": "Simpan dan sambung semula",
    "resetDefault": "Set semula asal",
    "invalidServerUrlTitle": "URL server tidak sah",
    "invalidServerUrlMessage": "Masukkan URL server http atau https yang sah, contohnya https://example.com",
    "uiLanguageChangeFailed": "Gagal tukar bahasa aplikasi. Sila cuba lagi.",
    "serverLanguageChangeFailed": "Gagal tukar bahasa sembang. Sila cuba lagi.",
    "timezoneChangeFailed": "Gagal tukar zon masa. Sila cuba lagi.",
    "autoSyncChangeFailed": "Gagal kemas kini selarasan automatik. Sila cuba lagi.",
    "nameChangeFailed": "Gagal kemas kini nama paparan. Sila cuba lagi.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "Butiran peringatan",
    "editTime": "Sunting Masa",
    "rename": "Tukar nama",
    "snooze": "Tunda",
    "snooze15": "Tunda 15 minit",
    "pause": "Jeda",
    "pauseReminder": "Jeda peringatan",
    "resume": "Sambung",
    "resumeReminder": "Sambung peringatan",
    "skip": "Langkau Seterusnya",
    "skipOccurrence": "Langkau kejadian ini",
    "syncGoogle": "Selaraskan ke Google",
    "delete": "Padam",
    "deleteTitle": "Padam Peringatan",
    "deleteConfirm": "Peringatan ini akan dipadam secara kekal.",
    "deleteRecurringTitle": "Padam Peringatan Berulang",
    "deleteRecurringMessage": "Anda mahu langkau kejadian ini atau padam keseluruhan siri?",
    "deleteThisOccurrence": "Langkau Kejadian Ini",
    "deleteEntireSeries": "Padam Keseluruhan Siri",
    "done": "Selesai",
    "markDone": "Tandakan sebagai selesai",
    "undo": "Pulihkan",
    "undoPrompt": "Perlukan ia aktif semula? Pulihkan sekarang.",
    "recurring": "Berulang",
    "nextRun": "Jalankan seterusnya",
    "oneTime": "Sekali sahaja",
    "pending": "Tertunda",
    "sent": "Dihantar",
    "paused": "Dijeda",
    "active": "Aktif",
    "snoozed": "Ditunda",
    "localTime": "Dipaparkan dalam masa tempatan anda",
    "recurrence": "Kekerapan",
    "created": "Dicipta",
    "tags": "Tag",
    "fireCount": "Kali diaktifkan",
    "actions": "Tindakan",
    "none": "Tiada",
    "snoozeFailed": "Gagal tunda peringatan",
    "pauseFailed": "Gagal jeda peringatan",
    "resumeFailed": "Gagal sambung peringatan",
    "skipFailed": "Gagal langkau peringatan",
    "doneFailed": "Gagal tandakan peringatan selesai",
    "undoFailed": "Gagal pulihkan status peringatan",
    "deleteFailed": "Gagal padam peringatan",
    "rescheduleTitle": "Jadual semula?",
    "rescheduleMsg": "Peringatan ini lewat. Mahu jadual semula?",
    "reschedule15": "Dalam 15 minit",
    "reschedule60": "Dalam 1 jam",
    "keepOverdue": "Biarkan seperti sedia ada"
  },
  "onboarding": {
    "slide1Title": "Selamat datang ke FishMemory",
    "slide1Sub": "Pembantu peringatan peribadi anda — dikuasakan oleh WhatsApp dan dibina untuk poket anda.",
    "slide2Title": "Cuma Sembang Secara Semula Jadi",
    "slide2Sub": "Taip peringatan seperti yang anda fikir: \"Ingatkan saya hubungi ibu esok jam 3 petang\" — kami uruskan selebihnya.",
    "slide3Title": "Jangan Terlepas Apa-apa",
    "slide3Sub": "Terima pemberitahuan tepat pada masa, susun dengan tag, dan kekal teratur dengan semua perkara penting.",
    "getStarted": "Mula",
    "next": "Seterusnya",
    "firstReminderTitle": "Buat peringatan pertama anda!",
    "firstReminderHint": "Cuba taip sesuatu seperti:",
    "firstReminderExample": "Ingatkan saya minum air esok jam 9 pagi",
    "gotIt": "Faham!",
    "notifRationaleTitle": "Sentiasa Tepat Masa",
    "notifRationaleBody": "FishMemory perlukan pemberitahuan untuk ingatkan anda tepat masa. Anda hanya akan terima amaran untuk peringatan yang anda buat.",
    "notifRationaleAllow": "Benarkan Pemberitahuan",
    "notifRationaleLater": "Mungkin Nanti",
    "swipeHint": "Leret ke kanan untuk tindakan cepat →",
    "calendarDragHint": "Seret untuk kembangkan ↕"
  }
}
